const config = {
  apiGateway: {
    REGION: 'us-west-2',
    INTERNAL_API_URL: 'https://0cj7onh822.execute-api.us-west-2.amazonaws.com/prod',
    COMPANY_API_URL: 'https://hlz7j0hlnj.execute-api.us-west-2.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'taxonomy-company-1.13.4',
    HOSTNAME: 'https://company.staging.teck.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.staging.teck.forwoodsafety.com',
    WEBSOCKET: 'wss://hop65qwi7i.execute-api.us-west-2.amazonaws.com/staging'
  },
};

export default config;